module.exports = __webpack_public_path__ + "img/no-image-placeholder-single.14240d63.png";